import Slides from './Slides.js';

import img1 from './images/portfolio/parties-and-events/001.jpg';
import img2 from './images/portfolio/parties-and-events/006.jpg';
import img3 from './images/portfolio/parties-and-events/082.jpg';
import img4 from './images/portfolio/parties-and-events/115.jpg';
import img5 from './images/portfolio/parties-and-events/138.jpg';
import img6 from './images/portfolio/parties-and-events/Class_of_72.jpg';
import img7 from './images/portfolio/parties-and-events/Class_of_1954.jpg';
import img8 from './images/portfolio/parties-and-events/IMG_094.jpg';
import img9 from './images/portfolio/parties-and-events/Img028.jpg';
import img10 from './images/portfolio/parties-and-events/Img153.jpg';
import img11 from './images/portfolio/parties-and-events/Img212.jpg';
import img12 from './images/portfolio/parties-and-events/Page_1.jpg';
import img13 from './images/portfolio/parties-and-events/St._Doms_64.jpg';
import img14 from './images/portfolio/parties-and-events/IMG0089.jpg';
import img15 from './images/portfolio/parties-and-events/IMG0097.jpg';
import img16 from './images/portfolio/parties-and-events/IMG0546.jpg';
import img17 from './images/portfolio/parties-and-events/IMG2287.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
    img17,
];

function ChurchesSchoolsAndSports() {
    return <Slides images={images}/>;
}

export default ChurchesSchoolsAndSports;
